"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require("../../utils"),
    mixin = _require.mixin;

var SVGListBase = require("./SVGListBase");

var SVGStringListImpl = function SVGStringListImpl(globalObject, args, privateData) {
  _classCallCheck(this, SVGStringListImpl);

  this._globalObject = globalObject;

  this._initList(privateData);
};

mixin(SVGStringListImpl.prototype, SVGListBase.prototype);
exports.implementation = SVGStringListImpl;